/**
 * Created by wahhajshamim on 2/15/16.
 */
/// <reference path="../app.definition.ts" />
import angular from 'angular';
import { Util } from '@common/util';
import _ from 'lodash';

angular
    .module('validation.rule', ['validation'])
    .config(['$validationProvider', function ($validationProvider) {
        let expression = {
            required: function (value, scope, element, attrs, param) {
                let returnValue;
                if (param == "false") {   //This is for conditional validator in directives.[customChoices.directive used in assignservice]
                    returnValue = true;
                } else if (value && value instanceof Array) {
                    returnValue = (value.length > 0);
                } else {
                    returnValue = !!value;
                }
                return returnValue;
            },
            name: function (value) {
                if (!!value) {
                    return /^[a-zA-Z0-9- '\u00C0-\u017F]+$/.test(value);
                } else {
                    return true;
                }
            },
            signFullName: function (value) {
                if (!!value) {
                    return /^[a-zA-Z' ]+$/.test(value);
                }
            },
            signInitials: function (value) {

                if (!!value) {
                    //yet to accomadate " and backslash
                    return /^[^/<>:|?*]*$/.test(value);
                }
            },
            foldername: function (value, scope, element, attrs, param) {
                if (!!value && attrs.fieldType === "Folder") {
                    const rg1 = /^[^\\/:*?"<>|^]+$/; // forbidden characters \ / : * ? " < > |
                    return rg1.test(value) && !_.startsWith(value, '.');
                }
                return true;
            },
            url: /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)(?:\/[\+~%\/.\w-_]*\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/,
            email: function (value) {
                if (!!value) {
                    return /^(?!.*\.\.)(?!.*\.@)[A-Za-z0-9._!#^+'~-]{1,64}@(?![^@]{49})[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(value);
                }
                else
                    return true;
            },
            youtubeLink: function (value) {
                if (!!value) {
                    return Util.youtubeUrlRegex.test(value);
                }
                else
                    return true;
            },
            number: /^\d+$/,
            minlength: function (value, scope, element, attrs, param) {
                let result = true;
                let message = '';
                if (!!value) {
                    result = value.length >= param;
                    message = 'This field should have ' + param + ' characters or more.';
                }
                return { result, message }
            },
            maxlength: function (value, scope, element, attrs, param) {
                let result = true;
                let message = '';
                if (!!value) {
                    result = value.length <= param;
                    message = 'This field should have ' + param + ' characters or less.';
                }
                return { result, message }
            },
            minvalue: function (value, scope, element, attrs, param) {
                if (!!value) {
                    return value >= param;
                } else {
                    return true;
                }
            },
            maxvalue: function (value, scope, element, attrs, param) {
                if (!!value) {
                    return value <= param;
                } else {
                    return true;
                }
            },
            textareamaxlength: function (value, scope, element, attrs, param) {
                if (!!value) {
                    if (value.indexOf("\n") == -1) {
                        return value.length <= param;
                    }
                    let lines = value.split("\n");
                    let length = lines.reduce(function (sum, val, key) {
                        sum += val.length + 1;
                        return sum;
                    }, 0);
                    return length <= param;
                } else {
                    return true;
                }
            },
            tel: function (value, scope, element, attrs, param) {
                return !value || ($(element) as IPhoneInput).intlTelInput("isValidNumber");
            },
            date: function (value) {
                if (value === null) {
                    return true;
                }
                if (value === undefined) {
                    return true;
                }
                if (!!value) {
                    if (Object.prototype.toString.call(value) === "[object Date]") {
                        // it is a date
                        if (isNaN(value.getTime())) {  // d.valueOf() could also work
                            // date is not valid
                            return false;
                        }
                        else {
                            // date is valid
                            return true;
                        }
                    }
                    else {
                        // not a date
                        return /^(?:(?:(?:0[13578]|1[02]|(?:Jan|Mar|May|Jul|Aug|Oct|Dec))(\/|-|\.)31)\1|(?:(?:0?[1,3-9]|1[0-2]|(?:Jan|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec))(\/|-|\.)(?:29|30)\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:(?:0?2|(?:Feb))(\/|-|\.)(?:29)\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:(?:0[1-9]|(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep))|(?:1[0-2]|(?:Oct|Nov|Dec)))(\/|-|\.)(?:0[1-9]|1\d|2[0-8])\4(?:(?:1[6-9]|[2-9]\d)?\d{4})$/.test(value);

                    }
                } else {
                    return true;
                }
            },
            specialCharsName: function (value) {
                if (!!value) {
                    return /^([^<>]*)$/.test(value);
                } else {
                    return true;
                }
            }

        };

        let defaultMsg = {

            required: {
                error: 'This field is required.',
                success: 'It\'s Required'
            },
            name: {
                error: 'Name can only contain numbers, letters, dash, single quotes and spaces.',
                success: 'It\'s Required'
            },
            signFullName: {
                error: 'Name can only contain letters, apostrophe and spaces.',
                success: 'It\'s Signature'
            },
            signInitials: {
                error: 'Initials can only contain letters',
                success: 'It\'s Initial'
            },
            foldername: {
                error: "/ | \\ ^ \" : ? < > * characters are not allowed.",
                success: 'It\'s folder name'
            },
            url: {
                error: 'This should be Url',
                success: 'It\'s Url'
            },
            email: {
                error: 'Not a valid Email Address',
                success: 'It\'s Email'
            },
            youtubeLink: {
                error: 'Invalid YouTube URL',
                success: 'It\'s Youtube Link'
            },
            number: {
                error: 'This should be Number',
                success: 'It\'s Number'
            },
            minlength: {
                error: 'This field should be long enough.',
                success: 'Long enough!'
            },
            maxlength: {
                error: 'The characters in the field exceeds the maximum allowed length.',
                success: 'Short enough!'
            },
            minvalue: {
                error: 'This field should have greater value.',
                success: 'Big enough!'
            },
            maxvalue: {
                error: 'This field should have smaller value.',
                success: 'Small enough!'
            },
            textareamaxlength: {
                error: 'The characters in the field exceeds the maximum allowed length.',
                success: 'Short enough!'
            },
            tel: {
                error: 'Invalid Number',
                success: 'Valid!'
            },
            date: {
                error: 'Invalid Date format',
                success: 'Valid!'
            },
            specialCharsName: {
                error: 'Name contains invalid characters.',
                success: 'It\'s Required'
            }

        };
        $validationProvider.setExpression(expression).setDefaultMsg(defaultMsg);
    }]);
